import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const AccountChartWrapper = styled.div`
  ${({ theme }) => css`
    flex: 1 1 0;
    /* Encolhe com a tela para os painéis sempre caberem na linha, sem scroll */
    min-width: 0;

    .recharts-wrapper {
      padding-left: 0 !important;
      padding-right: 0 !important;
      outline: none !important;
      border: none !important;
    }
    .recharts-wrapper:focus,
    .recharts-wrapper:focus-visible {
      outline: none !important;
      border: none !important;
    }
    .recharts-surface {
      overflow: visible;
      outline: none !important;
    }
    .recharts-surface:focus,
    .recharts-surface:focus-visible {
      outline: none !important;
    }
    svg,
    svg:focus,
    svg:focus-visible {
      outline: none !important;
    }
    .recharts-cartesian-grid-horizontal,
    .recharts-cartesian-grid-vertical {
      display: none;
    }
    .recharts-bar-category {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
    .recharts-cartesian-axis-tick text {
      font-size: 12px;
      fill: #767676;
    }
    .recharts-bar-rectangle {
      margin: 0 !important;
      pointer-events: all !important;
    }
    .recharts-bar {
      pointer-events: all !important;
    }
    .recharts-bar-rectangle:hover {
      opacity: 1 !important;
      cursor: pointer;
    }
    .recharts-cartesian-axis-tick {
      margin: 0 !important;
    }
    .recharts-tooltip-wrapper {
      outline: none;
      z-index: 2;
    }
    .recharts-default-tooltip {
      border-radius: 10px;
      border: 1px solid ${theme.colors.background.hover} !important;
      background: ${theme.colors.lightest};
      box-shadow: 4px 4px 8px 0 ${theme.colors.background.hover} !important;
    }
    .recharts-tooltip-label {
      margin-bottom: 4px !important;
      font-weight: 600 !important;
    }
    .recharts-tooltip-item {
      margin-top: 4px !important;
    }
    /* Remove a linha vertical do cursor */
    .recharts-tooltip-cursor,
    .recharts-cursor {
      display: none !important;
    }

    .recharts-active-bar {
      display: none !important;
    }

    .recharts-bar:hover ~ .recharts-bar .recharts-bar-rectangle,
    .recharts-bar:hover .recharts-bar-rectangle {
      opacity: 1 !important;
    }
  `}
`
